import React from 'react';
import {User} from "types/User";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {useAuth} from "../../../context/AuthContext";

type DisableTwoFactorAuthProps = {
    user: User
    show: boolean
    onDisable?: (user: User) => void
    onCancel: () => void
}

function DisableTwoFactorAuth(props: DisableTwoFactorAuthProps) {
    const {user, show, onDisable, onCancel} = props
    const auth = useAuth();

    const {notify} = useNotifications();
    const {mutateAsync: disableTwoFactorAuth} = useMutation(ngage.auth.twoFactorDisable, {
        onSuccess: async () => {
            await auth.refetchCurrentUser();
            await invalidate(['users', {id: user.id}], { refetchInactive: true });

            // Call the onDisable callback if provided
            onDisable?.(user);

            // Show success notification
            notify("success", "Two-factor authentication", '2FA disabled successfully.')
        },
        onError: async () => {
            notify("error", "Two-factor authentication", 'Sorry, 2FA could not be disabled.');
            onCancel();
        }
    });

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Two-factor authentication"
            body={`Are you sure you want to disable this authentication?`}
            approveLabel="Disable"
            onApprove={disableTwoFactorAuth}
            onCancel={onCancel}
        />
    );
}

export default DisableTwoFactorAuth;